import { HourlyForecastTimelineSegment } from '../models/HourlyForecastTimelineData';
import { formatVisibility } from './visibilityFormatters';

export const FOG_800M_COLOR = '#d32f2f';
export const FOG_1600M_COLOR = '#f57c00';
export const FOG_3000M_COLOR = '#ffd54f';
export const NO_FOG_COLOR = '#4caf50';
export const NO_DATA_COLOR = '#757575';
export const NOW_LINE_COLOR = '#ba68c8';

export const getSegmentColor = (segment: HourlyForecastTimelineSegment | null): string => {
  if (!segment) return NO_DATA_COLOR;
  if (segment.visibility_level != null) {
    if (segment.visibility_level <= 800) return FOG_800M_COLOR;
    if (segment.visibility_level <= 1600) return FOG_1600M_COLOR;
    if (segment.visibility_level <= 3000) return FOG_3000M_COLOR;
    return NO_FOG_COLOR;
  }
  return segment.fog_predicted ? NO_DATA_COLOR : NO_FOG_COLOR;
};

export const getVisibilityLabel = (segment: HourlyForecastTimelineSegment | null): string => {
  if (!segment) return 'No Data';
  if (segment.visibility_level != null) {
    if (segment.visibility_level <= 800) return `≤ ${formatVisibility(800)}`;
    if (segment.visibility_level <= 1600) return `≤ ${formatVisibility(1600)}`;
    if (segment.visibility_level <= 3000) return `≤ ${formatVisibility(3000)}`;
    return `> ${formatVisibility(3000)}`;
  }
  if (segment.fog_predicted === false) return `> ${formatVisibility(3000)}`;
  return 'No Data';
};

export function getVisibilityColor(value: number | null | undefined): string {
  if (value === null || value === undefined || isNaN(value)) return NO_DATA_COLOR;
  if (value <= 800) return FOG_800M_COLOR;
  if (value <= 1600) return FOG_1600M_COLOR;
  if (value <= 3000) return FOG_3000M_COLOR;
  return NO_FOG_COLOR;
}
